import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import useHelpers from 'hooks/helpers';
import { standardFormatLong } from 'constants/dateFormats';
import { usePageData } from 'lib/page-data/PageDataContext';
import { useSitecoreContext } from 'hooks/useSitecoreContext';

const PressReleaseHero = ({ rendering }: ComponentProps) => {
  const { localizeDate } = useHelpers();
  const { pressReleaseData } = usePageData('pressRelease') ?? {};
  const { sitecoreContext } = useSitecoreContext();

  const title = pressReleaseData.pressReleaseTitle ?? '';
  const publicationDate = pressReleaseData.pressReleasePublicationDate.formattedDateValue ?? '';
  const showBanner = (!!title && !!publicationDate) || sitecoreContext.pageEditing;

  if (!showBanner) return null;

  return (
    <section
      data-e2e-component-uid={rendering.uid}
      className="py-4 py-lg-7 text-white background-primary"
    >
      <div className="container pt-1 pt-md-5 pt-lg-6">
        <div className="row">
          <div className="col-12 col-md-8 col-lg-9">
            <Text tag="h1" className="mb-2" field={title} />
            <span className="body-large">{localizeDate(publicationDate, standardFormatLong)}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PressReleaseHero;
